<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <h2>{{ partnerName }}</h2>
            <hr class="h2" />
            <h3>Welcome, {{ userName }} </h3>
            <div class="flex-container">
                <div>
                    <div class="container">
                        <!--Dashboard cards with partner statistics -->
                        <!-- <PartnerDashTiles /> -->
                    </div>
                    <button v-if="partnerGuid.toUpperCase() === 'E1F8424BEECC40A6819E3683245CB636'" class="title-btn"
                        @click="navigateToAddCampaign">
                        <font-awesome-icon icon="fa-address-book" />
                        CREATE A NEW OUTBOUND CAMPAIGN
                    </button>
                    <button v-if="partnerGuid.toUpperCase() === 'E1F8424BEECC40A6819E3683245CB636'" type="button"
                        class="title-btn" @click="navigateToUpdateContractorsList">
                        <font-awesome-icon icon="fa-address-book" />
                        UPDATE CONTRACTORS LISTS
                    </button>
                    <div class="container">
                        <h3>Customers</h3>
                        <CustomerTable />
                    </div>
                </div>

                <div class="right-section">
                    <div class="container">
                        <!--Opportunities in pipeline pie chart-->
                        <OpportunitiesChart />
                    </div>
                    <div class="container">
                        <!-- Bot provisioning status chart -->

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'
import PartnerDashTiles from '../vuetify/PartnerDashTiles.vue'
import CustomerTable from '../vuetify/CustomerTable.vue'
import OpportunitiesChart from '../vuetify/OpportunitiesChart.vue'



export default {
    name: 'PartnerDashboard',
    components: {
        SideBar,
        OpportunitiesChart,
        PartnerDashTiles,
        CustomerTable,
    },
    data() {
        return {
            partnerGuid: '',
            partnerName: '',
            userName: '',
            userRole: '',

        };
    },
    mounted() {
        this.partnerGuid = localStorage.getItem('partnerGuid') || '';
        if (!this.partnerGuid) {
            this.$router.push('/home');
        }

        this.partnerName = localStorage.getItem('partnerName') || '';
        this.userName = localStorage.getItem('userName') || '';
        this.userRole = localStorage.getItem('userRole') || '';

        // Clear other bot-specific items
        localStorage.removeItem('customerName');
        localStorage.removeItem('botName');
        localStorage.removeItem('botID');
        localStorage.removeItem('botType');
        localStorage.removeItem('botDID');

        // If this partner is the fleet partner, set the associated customerGUID for fleet operations
        if (this.partnerGuid && this.partnerGuid.toUpperCase() === 'E1F8424BEECC40A6819E3683245CB636') {
            localStorage.setItem('customerGUID', 'AD19537023AE4333B185521BF7078F60');
            localStorage.setItem('customerName', 'Fleet Plant Hire Outbound');
            localStorage.setItem('customerCountry', 'Australia');
            localStorage.setItem('customerEmail', 'jade.west@fph.com.au');
        }
    },
    methods: {
        navigateToAddCampaign() {
            this.$router.push({ name: 'PartnerFleetOutboundCampaign' });
        },
        navigateToUpdateContractorsList() {
            this.$router.push({
                path: '/partner/customer',
                query: { activeTab: 'contractorLists' }
            });
        },
    },
};
</script>


<style scoped>
h1 {
    margin-top: 10px;
}

.flex-container {
    display: flex;
    flex-direction: row;
}

.container {
    /*max-width: 980px;*/
    margin: 20px;
}

.tile {
    display: inline-block;
}

.left-section {
    max-width: 760px;
    width: 70%;
}

.right-section {
    max-width: 400px;
    width: 25%;
}

.bottom-section {
    width: 100%;
    padding-top: 10px;
}

.title-btn {
    background-color: #E45F2B;
    color: white;
    font-size: 16px;
}

.title-btn:hover {
    background-color: #000000;
}
</style>